import { TransparentItemProps } from './transparent-pricing.types'

export enum TransparentPricingItemKey {
  MATERIALS = 'materials',
  CRAFTING = 'crafting_cost',
  PACKAGING = 'packaging',
  FREIGHT_HANDLING = 'freight_handling',
  CREDIT_CARD_FEES = 'credit_card_fees',
  DUTIES_TAXES_AND_FEES = 'duties_taxes_and_fees',
  SOCK_DONATION = 'sock_donation',
}
/**
 * Structural cost fields shared by the PL proto variant (`TransparentPricingVariant`) and the legacy
 * domain object (`TransparentPricingItem`). Every field is optional so both shapes assign cleanly and a
 * partial/undefined input is safe.
 */
export interface TransparentPricingCostFields {
  materials?: number
  hardware?: number
  crafting?: number
  packaging?: number
  shippingHandling?: number
  creditCardFees?: number
  dutyFee?: number
  sockDonationCost?: number
}

/**
 * Build the labelled transparent-pricing rows shared by the PL widget and the legacy product/bundle
 * sections — the single source of truth so every surface renders the exact same rows.
 *
 * `materials` folds in `hardware`; the `duty` and `sock-donation` rows are appended only when present.
 * Pure given the translate fn.
 */
export const buildTransparentPricingItems = (
  costs: TransparentPricingCostFields | undefined,
  t: (key: string) => string,
): TransparentItemProps[] => {
  const items: TransparentItemProps[] = [
    { name: t(TransparentPricingItemKey.MATERIALS), value: (costs?.materials ?? 0) + (costs?.hardware ?? 0) },
    { name: t(TransparentPricingItemKey.CRAFTING), value: costs?.crafting ?? 0 },
    { name: t(TransparentPricingItemKey.PACKAGING), value: costs?.packaging ?? 0 },
    { name: t(TransparentPricingItemKey.FREIGHT_HANDLING), value: costs?.shippingHandling ?? 0 },
    { name: t(TransparentPricingItemKey.CREDIT_CARD_FEES), value: costs?.creditCardFees ?? 0 },
  ]
  if (costs?.dutyFee) {
    items.push({ name: t(TransparentPricingItemKey.DUTIES_TAXES_AND_FEES), value: costs.dutyFee })
  }
  if (costs?.sockDonationCost) {
    items.push({ name: t(TransparentPricingItemKey.SOCK_DONATION), value: costs.sockDonationCost })
  }
  return items
}
